// components/HeaderBar.js
import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AnimatedCanvas from "./animations/AnimatedCanvas";

const HeaderBar = () => {
    return (
        <AppBar position="static" style={{ position: 'relative', overflow: 'hidden' }}>
            {/* Animated canvas inserted as background */}
            <AnimatedCanvas />
            <Toolbar style={{ background: 'transparent' }}>
                <img
                    alt="Logo"
                    src="/logo.png"
                    height="40"
                    style={{ margin: 10, position: 'relative', zIndex: 1 }}
                />
                <Typography
                    variant="h6"
                    component="div"
                    style={{ fontFamily: 'Poppins', position: 'relative', zIndex: 1 }}
                >
                    Search Librarian
                </Typography>
            </Toolbar>
        </AppBar>
    );
};

export default HeaderBar;
